<template>
  <div class="notfound-page">
    <section class="top">
      <img @click="goHome" class="logo" src="@/assets/images/logo--dark.svg" alt="logo" />
    </section>
    <section class="main">
      <h1 id="title">404</h1>
      <h3>Sorry, we can't find that page<br>
      Try going <router-link to="/">Home</router-link></h3>
    </section>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
  methods: {
    goHome: function() {
      return this.$router.push('/');
    }
  }
};
</script>

<style lang="scss" scoped>
.notfound-page {
  background-color: $background;
  height: 100vh;
}
.top {
  background-color: $white;
  padding: 0.75rem 0;
}
.logo {
  height: 2.5rem;
}
.main {
  padding: 1rem;
  text-align: left;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: $black;
    text-align: center;
  }
}
#title {
  text-align: center;
  color: $primary;
  font-size: 3.14rem;
}
a {
  color: $primary;
}
</style>
